// API URLs
export const PROSPECT_PATH = '/accounts/me'
export const FINANCIAL_ACCOUNTS_PATH = '/financial_accounts'
export const GET_JOINT_OWNER_PATH = '/financial_accounts/:financialAccountId/joint_owners'
export const UPDATE_JOINT_OWNER_PATH = '/financial_accounts/:financialAccountId/joint_owners/:jointOwnerId'
export const UPDATE_FINANCIAL_ACCOUNT_PATH = '/financial_accounts/:financialAccountId'
export const CONTACTS_PATH = '/contacts'
export const CONTACT_PATH = '/contacts/:contactId'
export const POST_FINANCIAL_ACCOUNT_ROLE_PATH = '/contact_financial_account_roles'
export const CONTACT_FINANCIAL_ACCOUNT_ROLES_PATH = '/contact_financial_account_roles'
export const CONTACT_FINANCIAL_ACCOUNT_ROLE_PATH = '/contact_financial_account_roles/:contactFinancialAccountRoleId'
export const RECIPROCAL_ROLES_PATH = '/reciprocal_roles'
export const CONTACT_TYPES_PATH = '/contact_types'



// WEBPACK FOOTER //
// ./src/utils/apiPaths.js